import { isStringArray } from '@/api/queries/utils';
import { OptionPathsByFilter } from '@/context/FiltersContext/FiltersContext';
import { FilterType } from '@/models/filter/FilterType';

const KNOWN_FILTER_TYPES: ReadonlySet<string> = new Set<string>(Object.values(FilterType));

/**
 * Validates the `optionPaths` entry of a saved-filter / shared-view payload.
 * Unknown keys are rejected rather than ignored: a payload written by a newer
 * app version must not seed the registry with paths this build cannot map to a
 * filter, or `applyFilter` would build its query from an unrelated universe.
 */
export const isOptionPathsByFilter = (value: unknown): value is OptionPathsByFilter => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) return false;

  return Object.entries(value).every(([filterKey, paths]) => KNOWN_FILTER_TYPES.has(filterKey) && isStringArray(paths));
};
